import React from 'react';

const IconPlus = ({ color, width, height }) => {
  return (
    <svg fill={color} height={height} width={width} viewBox="0 0 24 24">
      <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z" />
      <path d="M0 0h24v24H0z" fill="none" />
    </svg>
  );
};

export default IconPlus;



// WEBPACK FOOTER //
// ./src/IconPlus.js